import { useInfiniteQuery, useQuery } from '@tanstack/react-query'
import {
  getUserFiles,
  GetUserFilesParams,
  GetUserFilesResponse,
} from '../../../service/user'

export interface UseUserFilesParams {
  fileType?: 'ai_generated' | 'direct_upload'
  limit?: number
  enabled?: boolean
}

export const useUserFiles = ({
  fileType,
  limit = 20,
  enabled = true,
}: UseUserFilesParams = {}) => {
  return useInfiniteQuery({
    queryKey: ['user', 'files', limit],
    queryFn: async ({ pageParam = 1 }) => {
      const response = await getUserFiles({
        page: pageParam as number,
        limit,
      })
      return response
    },
    getNextPageParam: (lastPage: GetUserFilesResponse, allPages) => {
      return lastPage.hasMore ? lastPage.currentPage + 1 : undefined
    },
    initialPageParam: 1,
    enabled: !!fileType && enabled, // fileType이 있고 enabled가 true일 때만 호출
    staleTime: 0, // 항상 stale로 처리하여 새로 요청
    gcTime: 0, // 캐시를 즉시 삭제
  })
}

// 단순한 페이지네이션을 위한 훅 (필요한 경우)
export const useUserFilesSimple = (
  fileType?: 'ai_generated' | 'direct_upload',
  page = 1,
  limit = 20
) => {
  return useQuery({
    queryKey: ['user', 'files', page, limit],
    queryFn: () => getUserFiles({ page, limit }),
    enabled: !!fileType,
  })
}
